import i18next from 'i18next';

/**
 * Translate from outside a React component - thunks, class components, and
 * module-level helpers, none of which can use the `useTranslation` hook.
 *
 * `i18next.t` returns undefined until i18next has initialised, which would
 * render a toast or modal with no text at all. Since every key in this codebase
 * IS its English string, falling back to the key is both safe and readable, so
 * that is what happens whenever i18next cannot answer.
 */
export function translate(key: string, options?: Record<string, unknown>): string {
    if (i18next.isInitialized) {
        const translated = i18next.t(key, options as any);
        if (typeof translated === 'string' && translated) return translated;
    }
    return interpolate(key, options);
}

/** Fill `{{name}}` placeholders from `options`, the way i18next would. */
function interpolate(key: string, options?: Record<string, unknown>): string {
    if (!options) return key;
    return key.replace(/\{\{\s*([^}\s]+)\s*\}\}/g, (match, name) =>
        name in options ? String(options[name]) : match
    );
}

export default translate;
